export const EMPTY_ACTIONS = { mainActions: [], hiddenActions: [] }
export const LOADING_FIRST_QUERY = 1
export const LOADING_SECOND_QUERY = 2
